import { axiosPrivate } from 'shared/api';
import { BaseService } from 'shared/services/BaseService';
import toast from 'shared/utils/toast';
import { ITransportDocumentLine } from '../../types';

class TransportDocumentLineService extends BaseService<ITransportDocumentLine> {
  constructor() {
    super('transport-document-lines');
  }
  async getAllBaseInformation(params: Record<string, unknown> = {}) {
    try {
      const res = await axiosPrivate.get(`${this.modulePrefix}/`, { params });
      return res.data.results;
    } catch (e) {
      toast.error(e.message);
    }
  }
  invoicedMovements = async (limit = 0, offset = 0, params: Record<string, unknown> = {}) => {
    const ticketId = params.ticketId;
    const res = await axiosPrivate.get(`${this.modulePrefix}/${ticketId}/invoiced/`, {
      params: { limit, offset, ...params }
    });
    return res.data;
  };
}

export const transportDocumentLineService = new TransportDocumentLineService();
